import { render, staticRenderFns } from "./th-secondary.vue?vue&type=template&id=33934af4&scoped=true"
import script from "./th-secondary.vue?vue&type=script&lang=js"
export * from "./th-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33934af4",
  null
  
)

export default component.exports